<template>
    <a @click.prevent="select" class="text-sm no-underline text-white inline-flex items-center cursor-pointer" href="#">
        <img v-if="!displayValue" class="mr-1 w-6 h-6" src="../assets/un-checked-white.svg" alt="" />
        <img v-if="displayValue" class="mr-1 w-6 h-6" src="../assets/checked-white.svg" alt="" />
        <label class="theme-question-text-color theme-question-shadow input-label text-center mt-2 ml-1">
            {{ label }}
        </label>
    </a>
</template>

<script>
export default {
    name: 'Checkbox',

    props: {
        label: {
            type: String
        },
        value: {
            type: Boolean
        }
    },

    computed: {
        displayValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },

    methods: {
        select() {
            this.$emit('input', !this.displayValue)
        }
    }
}
</script>
